var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamondShape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.363 9.83C4.789 7.818 2.69 5.728.67 5.156c-.227-.073-.227-.233 0-.31C2.695 4.27 4.79 2.185 5.367.168c.062-.223.212-.223.274 0 .574 2.017 2.671 4.103 4.689 4.679.227.073.227.236 0 .31-2.021.57-4.12 2.661-4.693 4.675-.062.225-.212.225-.274 0z",
    fill: "url(#DiamondShape_svg__paint0_linear_3606_23144)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "DiamondShape_svg__paint0_linear_3606_23144",
    x1: 11.592,
    y1: 2.188,
    x2: -0.28,
    y2: 2.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#743DDC"
  })))));
}
export default SvgDiamondShape;